__turbopack_context__.v({
  "className": "frank_ruhl_libre_fb1a35bf-module__LW66aq__className",
});
